import React from 'react';
import { Eyebrow } from './Eyebrow';
import { IMAGES, VOLUMES } from '../data/landing';
export function WhatsInsideSection() {
  return <section className="bg-cream py-14 md:py-20" aria-labelledby="inside-title" data-id="element-239" data-mp="z8o98udfw7yv">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-240" data-mp="1dwst41o8apj8">
        <div className="mx-auto max-w-[620px] text-center" data-id="element-241" data-mp="195atbgxxyuzu">
          <Eyebrow data-id="element-242" data-mp="193pz5sfjhe2i">Qué incluye</Eyebrow>
          <h2 id="inside-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-243" data-mp="1mwp9zh4dmk3q">
            Seis tomos. Un solo sistema. De la confianza a la atracción.
          </h2>
          <p className="mx-auto mt-4 max-w-[460px] text-[13px] font-medium leading-relaxed text-ink-muted md:text-[15px]" data-id="element-244" data-mp="1wv50bhvkxpc6">
            No es una colección de PDFs sueltos. Es un recorrido progresivo
            donde cada tomo prepara el siguiente.
          </p>
        </div>

        <div className="mt-9 grid gap-6 md:grid-cols-[minmax(0,0.82fr)_minmax(0,1.18fr)] md:items-start md:gap-8" data-id="element-245" data-mp="3tnf0yope5v1b">
          <div className="mx-auto w-full max-w-[330px] md:mx-0 md:sticky md:top-8" data-id="element-246" data-mp="3eeieg82ljjp2">
            <div className="overflow-hidden rounded-[14px] border border-line bg-cream-soft" data-id="element-247" data-mp="3if16a24hopr9">
              <img src={IMAGES.bundleMockup} alt="Los seis tomos del Mega Pack Hombre Magnético" width={1024} height={1536} className="block h-auto w-full" loading="lazy" decoding="async" data-id="element-248" data-mp="3nenkads56a14" />
            </div>
            <p className="mt-2 text-center text-[10px] font-medium text-ink-muted md:text-left" data-id="element-249" data-mp="5wujmxri1ecw">
              6 tomos · formato digital
            </p>
          </div>

          <ol className="grid gap-3" data-id="element-250" data-mp="eyc3mr81206v">
            {VOLUMES.map((volume, index) => <li key={volume.title} className="flex gap-4 rounded-[12px] border border-line bg-cream-soft p-4" data-id="element-251" data-mp="2bqvr5crl7wxh" data-mpi={index}>
                <span className="pt-0.5 text-[11px] font-bold tracking-[0.06em] text-gold" data-id="element-252" data-mp="2gqgwq619j3j6">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div data-id="element-253" data-mp="3f2tbafr193v8">
                  <h3 className="text-[13px] font-bold text-ink md:text-[14px]" data-id="element-254" data-mp="3f3cjh4qvsdw2">
                    {volume.title}
                  </h3>
                  <p className="mt-1 text-[12px] font-medium leading-relaxed text-ink-muted md:text-[13px]" data-id="element-255" data-mp="3o2g3caxvgxbm">
                    {volume.text}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mt-9 text-center text-[10px] font-bold uppercase tracking-[0.16em] text-ink-muted" data-id="element-256" data-mp="1uggt2u3qv8u">
          6 tomos · ejercicios prácticos · acceso de por vida
        </p>
      </div>
    </section>;
}